<template>
    <main>
        <h4>
            {{ config.PROFILE_VIDEOS_TITLE }} ({{ validatedProjects.length }})
        </h4>
        <ProjectsList :projects="validatedProjects" @click="onProjectClick">
            <div slot="empty" class="empty">
                <p>Vous n'avez pas encore réalisé de vidéo</p>
                <ArtWarning :color="config.COLOR_WARNING"/>
            </div>
        </ProjectsList>
    </main>
</template>
<script>
import { SolutionConsumer, UserConsumer, ProjectConsumer } from '../../mixins';
import { ProjectsList } from '../../components/shared';

export default {
    name: 'ProfileVideos',
    components: { ProjectsList },
    mixins: [SolutionConsumer, UserConsumer, ProjectConsumer],
    methods: {
        onProjectClick (project) {
            this.$router.push({ name: 'project', params: { projectID: project.id } });
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

main {
    @include container(40px 20px);
    flex-grow: 1;
    background-color: $white;

    > h4 {
        text-transform: uppercase;
        color: $grey;
        margin: 0;
    }

    .empty {
        text-align: center;

        > svg {
            width: 200px;
        }
    }
}
</style>
